module.exports = __webpack_public_path__ + "img/Brett.91480a49.jpg";